import React, { Component } from 'react';
import { Container, Row, Col, Table,Card, CardBody, FormGroup,CardTitle, Button} from "reactstrap";
import { AvForm, AvField } from "availity-reactstrap-validation";
//Import Cards
import { Link } from "react-router-dom";
import MemberLoadCard from "../Components/MemberLoadCard";
import VehicleType from "../Components/VehicleType";
import GoodsType from "../Components/GoodsType";
import LoadType from "../Components/LoadType";
//Import Breadcrumb
import Breadcrumbs from '../../components/Common/Breadcrumb';
//Import Image
import img1 from "../../assets/images/Icon/Load.png";
class MemberLoadList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            projects: [
                {
                    id: 1, img: img1, vehicletype: "Pickup", pickupLocation: "Ajmer,Rajasthan 305001",destination: "Jaipur,Rajasthan 302020", date: "15 Oct, 19",goodsType:"House Hold",loadsType:"PartLoad",contactNumber:"9101525155",
                },
            ]
        }
    }
    render() {
        return (
            <React.Fragment>
                <div className="page-content">
                    <Container fluid>
                        {/* Render Breadcrumbs */}
                        <Breadcrumbs title="Post Load" breadcrumbItem="Member Load List" />
                        <Row>
              <Col lg={12}>
                <Card>
                  <CardBody>
                    <CardTitle>Search By Filter</CardTitle>
                    <AvForm>
                    <Row>
                     <Col md="2">
                        <VehicleType />
                      </Col>
                      <Col md="2">
                     <GoodsType/>
                       </Col>
                       <Col md="2">
                       <LoadType/>
                       </Col>
                       <Col md="4">
                       <AvField
                        name="searchText"
                        label="Search"
                        placeholder="Search..."
                        type="searchText"
                      /></Col>
                       <Col md="2">
                       <FormGroup className="mb-0 mt-4 ">
                        <div>
                          <Button type="submit" color="primary" className="mr-1">
                            Search
                        </Button>{" "}
                         
                        </div>
                      </FormGroup>
                           </Col>
                        </Row>
                     
                    </AvForm>
                  </CardBody>
                </Card>
              </Col>
            </Row>
                        <Row>
                        <Col sm="12">
                <div class="dataTables_info" role="status" aria-live="polite">Showing 1 to 10 of 57 entries</div>
                    </Col>
                            <Col lg="12">
                                <div className="">
                                    <div className="table-responsive">
                                        <Table className="project-list-table table-nowrap table-centered table-borderless">
                                            <thead>
                                                <tr>
                                                   
                                                    <th scope="col">Vehicle Type</th>
                                                    <th scope="col">Pickup Location</th>
                                                    <th scope="col">destination</th>
                                                    <th scope="col">Date</th>
                                                    <th scope="col">Goods Type</th>
                                                    <th scope="col">Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                            <MemberLoadCard projects={this.state.projects} />
                                            </tbody>
                                        </Table>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                        <Row>
                        <Col lg="12">
                 <nav aria-label="..." style={{float:'right'}}>
                                                    <ul className="pagination">
                                                        <li className="page-item disabled">
                                                            <Link className="page-link" to="#" tabIndex="-1">Previous</Link>
                                                        </li>
                                                        <li className="page-item"><Link className="page-link" to="#">1</Link></li>
                                                        <li className="page-item active">
                                                            <Link className="page-link" to="#">2 <span className="sr-only">(current)</span></Link>
                                                        </li>
                                                        <li className="page-item"><Link className="page-link" to="#">3</Link></li>
                                                        <li className="page-item">
                                                            <Link className="page-link" to="#">Next</Link>
                                                        </li>
                                                    </ul>
                 </nav>
                </Col>
                </Row>
                    </Container>
                </div>
            </React.Fragment>
        );
    }
}

export default MemberLoadList;